import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Description = () => (
  <DescriptionWrapper >
    <Link to='/'>
      <Logo
        src='/img/cms/create-event-logo.png'
        alt='HackHub'
      />
    </Link>
    <Message>
      HackHub is delicated in collaborating with our partners who help us
      develop our content and hire many of our program graduates.
    </Message>
    <Message>
      The companies and universities included on this website have either
      partnered, sponsored or have had students attend HackHub’s Hackathons.
    </Message>
  </DescriptionWrapper>
);

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  img:hover {
    cursor:pointer;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const Logo = styled.img`
  height: auto;
  width: 175px;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  margin: 0.5rem 0;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  width: 100%;

  @media only screen and (max-width: 768px) {
  padding: 1rem 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/footer/description.js